import React from "react";

function Legend(props) {
  return (
    <svg width={props.width} height={props.height}>
      <g transform={`translate(${40},${10})`}>
        <g>
          <circle cx={0} cy={0} r={6} fill="#81efde"></circle>
          {props.legend1 ? (
            <text x={20} y={5}>
              {props.legend1.slice(0, 22)}
            </text>
          ) : (
            <text x={20} y={5}>
              Portfolio
            </text>
          )}
        </g>
        <g>
          <circle cx={170} cy={0} r={6} fill="#4c6ead"></circle>

          {props.legend2 ? (
            <text x={190} y={5}>{`${props.legend2.slice(0, 22)}${
              props.legend2Star ? "*" : ""
            }`}</text>
          ) : (
            <text x={190} y={5}>
              Benchmark *
            </text>
          )}
        </g>
        {props.legend3 ? (
          <g>
            <circle
              cx={props.size == "small" ? 280 : 320}
              cy={0}
              r={6}
              fill="#8775a7"
            ></circle>
            <text x={props.size == "small" ? 300 : 340} y={5}>{`${
              props.legend3
            } ${props.legend3Star ? "*" : ""}`}</text>
          </g>
        ) : null}
      </g>
    </svg>
  );
}

export default Legend;



// WEBPACK FOOTER //
// ./src/components/d3Components/legend.js